import { ActivationFlow } from "../../../constants";

export const ResolvedActivationFlow = {
  COMPANY_MEMBER: "COMPANY_MEMBER",
  VOLUNTELL: "VOLUNTELL",
  PASSWORD_RESET: "PASSWORD_RESET",
} as const;
export type ResolvedActivationFlow =
  (typeof ResolvedActivationFlow)[keyof typeof ResolvedActivationFlow];

/**
 * Which activation a force-change-password visit belongs to.
 *
 * COMPANY_MEMBER is checked first because every voluntell-style auto-login —
 * teammate invites included — arrives with `activate=1` appended by
 * useAuthContext. Testing the param first attributed every teammate invite to
 * the voluntell flow, which is why COMPANY_MEMBER_ACCOUNT_ACTIVATION never
 * fired.
 */
export function resolveActivationFlow(
  flow: string | null,
  activateParam: string | null,
): ResolvedActivationFlow {
  if (flow === ActivationFlow.COMPANY_MEMBER) {
    return ResolvedActivationFlow.COMPANY_MEMBER;
  }
  if (
    flow === ActivationFlow.VOLUNTELL ||
    flow === ActivationFlow.VOLUNTELL_COMMAND_LINK ||
    activateParam
  ) {
    return ResolvedActivationFlow.VOLUNTELL;
  }
  return ResolvedActivationFlow.PASSWORD_RESET;
}

// Backend rejection codes that concern a phone field. Used only to decide
// whether to attach the attempted phone values to the SIGNUP_ERROR analytics
// event (so support can see the exact bad input) — not for user-facing copy,
// which mirrors the backend's own message.
const PHONE_ERROR_CODES = new Set([
  "INVALID_PHONE_NUMBER",
  "INVALID_PHONE_EXTENSION",
  "PHONE_IN_USE",
]);

export function isPhoneErrorCode(code: string): boolean {
  return PHONE_ERROR_CODES.has(code);
}

export function validatePassword(password: string): string | null {
  const passwordRegEx =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`])\S{8,99}$/;
  return passwordRegEx.test(password)
    ? null
    : "Password must be at least 8 characters and must contain lowercase letters, uppercase letters, a number and a symbol";
}
